"use client";
import Cookies from "js-cookie";
import { PROSPECTUS_LOCALE_COOKIE, LOCALE_TO_COOKIE_MAP } from "./constants";
import { getEnv } from "@/env";

const setLocaleCookie = async (locale: string) => {
  const cookieValue = LOCALE_TO_COOKIE_MAP[locale] || locale;
  Cookies.set(PROSPECTUS_LOCALE_COOKIE, cookieValue, {
    secure: true,
    path: "/",
    sameSite: "lax",
    domain: getEnv("COOKIE_DOMAIN") || ".edx.org",
  });
};

export default setLocaleCookie;
